module.exports = __webpack_public_path__ + "static/img/plate.2f8c94f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/plate.png
// module id = niwP
// module chunks = 2